import { Route, Routes } from 'react-router-dom'
import Login from "../pages/unauth/Login";
import OTPForm from '../pages/unauth/Login/otpform'
import SelfServiceRegistration from '../pages/unauth/SelfServiceRegistration'
import { useAuthState } from '../contexts/authcontext'
import UATChecklist from '../pages/shared/UATChecklist'
import VerifyEmail from '../pages/unauth/VerifyEmailInvite'
import UnauthShell from '../layouts/UnauthShell'

const UnAuthView = () => {
  let { isloggedin, isverified } = useAuthState()
  var view_otp_form = isloggedin && !isverified

  if (view_otp_form) {
    return <OTPAuthView />
  } else {
    return <LoginView />
  }
}


const OTPAuthView = () => {
  return (
    <div className='w-full'>
      <Routes>
          <Route path="*" element={<OTPForm  />}  />
      </Routes>
    </div>
  )
}


const LoginView = () => {
  return (
    <div className='w-full overflow-y-scroll'>
      <Routes>
        <Route path="self-service" element={<UnauthShell variant="chrome"><SelfServiceRegistration /></UnauthShell>} />
        <Route path="self-service/:event" element={<UnauthShell variant="chrome"><SelfServiceRegistration /></UnauthShell>} />
        <Route path="/uat" element={<UATChecklist />} />
        <Route path="/verify-email" element={<UnauthShell variant="chrome"><VerifyEmail /></UnauthShell>} />
        <Route path="*" element={<UnauthShell variant="marketing"><Login /></UnauthShell>} />
      </Routes>
    </div>
  )
}

export default UnAuthView;
